import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import axios from 'axios';
import './GuestModal.css';
import PhoneInput from './PhoneInput';

const AddGuestModal = ({ show, onHide, onGuestAdded }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    preferredLanguage: 'ar',
    notes: ''
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    setError(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.name.trim()) {
      setError('اسم الضيف مطلوب');
      return;
    }

    try {
      setLoading(true);
      setError(null);

      const token = localStorage.getItem('token');
      const response = await axios.post(
        '/api/guests',
        formData,
        {
          headers: { 'Authorization': `Bearer ${token}` }
        }
      );

      if (response.data.success) {
        // Reset form
        setFormData({
          name: '',
          email: '',
          phone: '',
          preferredLanguage: 'ar',
          notes: ''
        });

        // Notify parent and close
        if (onGuestAdded) {
          onGuestAdded(response.data.guest);
        }
        onHide();
      }
    } catch (err) {
      console.error('Error adding guest:', err);
      setError(
        err.response?.data?.message ||
        'حدث خطأ في إضافة الضيف'
      );
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setFormData({
      name: '',
      email: '',
      phone: '',
      preferredLanguage: 'ar',
      notes: ''
    });
    setError(null);
    onHide();
  };

  return (
    <Modal show={show} onHide={handleClose} centered dir="rtl">
      <Modal.Header closeButton>
        <Modal.Title>
          <i className="bi bi-person-plus me-2"></i>
          إضافة ضيف جديد
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {error && (
          <div className="alert alert-danger" role="alert">
            <i className="bi bi-exclamation-circle me-2"></i>
            {error}
          </div>
        )}

        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>
              الاسم <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="أدخل اسم الضيف"
              required
              disabled={loading}
              className="touch-input"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>البريد الإلكتروني</Form.Label>
            <Form.Control
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="example@email.com"
              disabled={loading}
              className="touch-input"
            />
            <Form.Text className="text-muted">
              اختياري - يُفضل إضافته للتواصل مع الضيف
            </Form.Text>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>رقم الهاتف</Form.Label>
            <PhoneInput
              value={formData.phone}
              defaultCountry="SA"
              onChange={(phone) => { setFormData(prev => ({ ...prev, phone })); setError(null); }}
              disabled={loading}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>اللغة المفضلة</Form.Label>
            <Form.Select
              name="preferredLanguage"
              value={formData.preferredLanguage}
              onChange={handleChange}
              disabled={loading}
              className="touch-select"
            >
              <option value="ar">العربية</option>
              <option value="en">English</option>
            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>ملاحظات</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              name="notes"
              value={formData.notes}
              onChange={handleChange}
              placeholder="ملاحظات إضافية عن الضيف..."
              disabled={loading}
              className="touch-input"
            />
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer className="touch-modal-actions">
        <Button variant="secondary" onClick={handleClose} disabled={loading} className="touch-btn">
          إلغاء
        </Button>
        <Button
          variant="primary"
          onClick={handleSubmit}
          disabled={loading || !formData.name.trim()}
          className="touch-btn"
        >
          {loading ? (
            <>
              <span className="spinner-border spinner-border-sm me-2" />
              جاري الإضافة...
            </>
          ) : (
            <>
              <i className="bi bi-check-lg me-2"></i>
              إضافة الضيف
            </>
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AddGuestModal;
